<template>
  <NuxtLink :to="startUrl">
    <div class="text-coral flex items-end gap-2">
      <AtomIcon name="bb-logo-name" />
    </div>
  </NuxtLink>
</template>

<script setup>
const fat = useFatStore()

// Set start URL
const startUrl = '/'
</script>

<style lang="scss" scoped>
.app-nav {
  @apply grid gap-12;
}
</style>